import {createReducer, on} from '@ngrx/store';
import {ActiveRouterTabActions} from '@aviary/store/active-router-tab/active-router-tab.actions';
import {ActiveRouterTabState} from '@aviary/store/active-router-tab/active-router-tab.types';

export const INITIAL_ACTIVE_ROUTER_TAB_STATE: ActiveRouterTabState = {};

export const activeRouterTabState = createReducer(
  INITIAL_ACTIVE_ROUTER_TAB_STATE,
  on(ActiveRouterTabActions.save, (state, {parentRouteName, routeName}) => ({
    ...state,
    [parentRouteName]: routeName
  })),
  on(ActiveRouterTabActions.clear, (state, {parentRouteName}) => ({
    ...state,
    [parentRouteName]: undefined
  }))
);
